<template>
  <div class="step-3">
    <div class="header">
      <div class="icon">
        <i class="isif isif-check" />
      </div>
      <div class="title">
        {{ $t('booking.reserveSuccess') }}
      </div>
    </div>
    <div class="details">
      <div class="date">
        {{ details.date }}
      </div>
      <div class="time">
        {{ details.time }}
      </div>
      <div class="timezone">
        <i class="isif isif-globe" />{{ bookings.timezone }}
      </div>
    </div>
    <div class="description">
      {{ $t('booking.thanksUser') }} {{ name }}<br>
      {{ $t('booking.confirmingEmail') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookingStep3',
  props: {
    bookings: {
      type: Object,
      default: () => ({})
    },
    details: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.step-3 {
  display: flex
  flex-direction: column
}
.header {
  flex: 1.5
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center

  .icon {
    width: 48px
    height: 48px
    line-height: 48px
    background: #79BB74
    display: flex
    justify-content: center
    align-items: center
    font-size: 26px
    border-radius: 50%

    i {
      color: #FFF
    }
  }
  .title {
    font-weight: bold
    margin-top: 15px
  }
}
.details {
  flex: 1.5
  text-align: center
  line-height: 30px
  margin-top: 20px

  .timezone {
    i {
      margin-right: 5px
    }
  }
}
.description {
  flex: 2
  width: 500px
  margin: 40px auto 0
  line-height: 30px
}
</style>
